import React from 'react';
import { createStore } from 'polotno/model/store';
import { PolotnoContainer, SidePanelWrap, WorkspaceWrap } from 'polotno';
import Sidebar from '../../../components/Sidebar';
import TshirtSize from './TshirtSize/TshirtSize';
// import SizeSelector from './TshirtSize/SizeSelector';
import SizeSelecorUi from './TshirtSize/SizeSelectorUi';
import SizeSelectorUiNew from './TshirtSize/SizeSelectorUiNew';
// import './TshirtSize/artboard-main.css';
import './TshirtSize/sizesNew.css';

const store = createStore({
	key: 'gj22OYPNEiZGOv4RvhGx',
	showCredit: true,
});

const Sizes = () => {
	return (
		<PolotnoContainer style={{ width: '100vw', height: '100vh' }}>
			<SidePanelWrap>
				<div class='left-main-menu'>
					<div class='left-main-menu--container'>
						<Sidebar store={store} />
					</div>
				</div>
			</SidePanelWrap>
			<WorkspaceWrap>
				<div className='artboard'>
					{/* <TshirtSize/> */}
					{/* <SizeSelector /> */}
					{/* <SizeSelecorUi />  commented by sakshi, for temporary work*/}
					<SizeSelectorUiNew /> 
				</div>
			</WorkspaceWrap>
		</PolotnoContainer>
	);
};

export default Sizes;
